import { UnknownAction } from 'redux'
import type { DesignPersonalizationContext } from '@vp/personalization-types'
import {
  DESIGN_PERSONALIZATION_CONTEXT_UPDATE,
  DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE,
  DPCS_LOADING_UPDATE,
  NEW_MODULE_HAS_IMAGE_UPDATE,
  NEW_MODULE_HAS_COLOR_UPDATE,
  COLOR_VARIATION_DPCS_UPDATE,
} from '~/app/store/designPersonalization/reducer'

export const designPersonalizationContextUpdate = (dpc?: DesignPersonalizationContext | undefined): UnknownAction => ({
  type: DESIGN_PERSONALIZATION_CONTEXT_UPDATE,
  payload: { dpc },
})

export const designPersonalizationContextIdUpdate = (id?: string | undefined): UnknownAction => ({
  type: DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE,
  payload: { id },
})

export const dpcsLoadingUpdate = (dpcsLoading: boolean): UnknownAction => ({
  type: DPCS_LOADING_UPDATE,
  payload: { dpcsLoading },
})

export const designPersonalizationWidgetHasImageUpdate = (designPersonalizationWidgetHasImage: boolean): UnknownAction => ({
  type: NEW_MODULE_HAS_IMAGE_UPDATE,
  payload: { designPersonalizationWidgetHasImage },
})

export const designPersonalizationWidgetHasColorUpdate = (designPersonalizationWidgetHasColor: boolean): UnknownAction => ({
  type: NEW_MODULE_HAS_COLOR_UPDATE,
  payload: { designPersonalizationWidgetHasColor },
})

export const colorVariationDPCsUpdate = (colorVariationDPCs: string[]): UnknownAction => ({
  type: COLOR_VARIATION_DPCS_UPDATE,
  payload: { colorVariationDPCs },
})
